var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-dialog',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._t("default",null,null,{ close: _vm.close })],2)}
var staticRenderFns = []

export { render, staticRenderFns }